import styled from "styled-components";
import { MDBPaginationLink } from "mdb-react-ui-kit";

export const PaginationLink = styled(MDBPaginationLink)`
  ${({ hover }) => hover && "background-color: green !important;"}
  ${({ hover }) => hover && "color: white !important;"}
  cursor: pointer;
`;
